import React from "react";
import { CheckCircle2} from "lucide-react";
import Button from "components/button";
import IndexModal from "components/modal";

const AdvanceCandidate = ({ 
    candidateName, 
    isOpen, 
    onClose, 
    onConfirm 
}) => {
    return (
        <IndexModal
            open={isOpen}
            onClose={onClose}
            useCustomClass
            width="sm:max-w-lg max-w-2xl"
            maxContentHeight="85vh"
            title={null}
            closable={false}
        >
            <div className="grid w-full gap-4 rounded-xl border p-6 shadow-xl max-w-lg">
                <div className="flex flex-col gap-2 text-left">
                    <h2 className="text-lg font-semibold">
                        Advance Candidate Stage
                    </h2>
                    <p className="text-sm text-slate-500">
                        Are you sure you want to advance {candidateName} to the next stage in the pipeline?
                    </p>
                </div>

                <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                    <Button
                        onClick={onClose}
                        className="inline-flex items-center justify-center gap-2 px-4 py-2 h-9
                                rounded-lg border hover:shadow-none hover:bg-slate-100"
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={onConfirm}
                        className="access-button btn-advance"
                    >
                        <CheckCircle2 className="w-3 h-3" />
                        Advance
                    </Button>
                </div>
            </div>
        </IndexModal>
    );
};

export default AdvanceCandidate;
